<template>
    <div class="container">     
        <top-bar title="产品帮助" has-back></top-bar>
        <device-card host="productinfo"></device-card>
        <div class="item">
            <form action="/">
                <van-search
                    v-model="searchValue"
                    placeholder="请输入型号关键词"
                    left-icon="search"
                    shape="round"
                    :show-action="true"
                    @blur="onSearch"
                    @cancel="onCancel"
                />
            </form>
            <div>
                <van-collapse v-model="activeNames">
                    <van-collapse-item name="1">
                        <template #title>
                            <div>安装指南 <van-badge :content="guideNumber" max="9"/></div>
                        </template>
                        <van-cell-group inset>
                            <van-cell 
                                v-for="item in guidelist" 
                                :key="item.RecID" 
                                :title="item.FileCaption"
                                :label="item.detail"
                                icon="star"
                                @click="handleItemClick(1, item.FileURL, item.ViewURL)"	
                                is-link 
                                arrow-direction="down" 
                                class="item-cell"	 
                            />   
                        </van-cell-group>
                    </van-collapse-item>
                    
                    <van-collapse-item name="2">     
                        <template #title>
                            <div>用户手册 <van-badge :content="manualNumber" max="9"/></div>
                        </template>                  
                        <van-cell-group inset>
                            <van-cell 
                                v-for="item in manuallist" 
                                :key="item.RecID" 
                                :title="item.FileCaption"
                                :label="item.detail"
                                icon="label"
                                @click="handleItemClick(2, item.FileURL, item.ViewURL)"	
                                is-link 
                                arrow-direction="down" 
                                class="item-cell"	 
                            />   
                        </van-cell-group>
                    </van-collapse-item>          
                    
                    <van-collapse-item name="3">
                        <template #title>
                            <div>安装视频 <van-badge :content="videoNumber" max="9"/></div>
                        </template>
                        <van-cell-group inset>
                            <van-cell 
                                v-for="item in videolist" 
                                :key="item.RecID" 
                                :title="item.FileCaption"
                                :label="item.detail"
                                icon="video"
                                @click="handleItemClick(3, item.FileURL, '')"	
                                is-link 
                                arrow-direction="down" 
                                class="item-cell"	 
                            />   
                        </van-cell-group>
                    </van-collapse-item>
                    
                    <van-collapse-item name="4">
                        <template #title>
                            <div>使用问答 <van-badge :content="qaNumber" max="99"/></div>
                        </template>
                        <van-cell-group inset>
                            <van-cell 
                                v-for="item in qalist" 
                                :key="item.qaid" 
                                :title="item.title"
                                :label="item.keywords"
                                icon="question"
                                @click="handleItemClick(4, item.qaid, '')"	
                                is-link 
                                arrow-direction="down" 
                                class="item-cell"	 
                            />   
                        </van-cell-group>
                    </van-collapse-item>
                    
                    <van-collapse-item name="5">
                        <template #title>
                            <div>驱动 <van-badge :content="driverNumber" max="99"/></div>
                        </template>
                        <van-cell-group inset>
                            <van-cell 
                                v-for="item in driverlist" 
                                :key="item.RecID" 
                                :title="item.detail"
                                icon="setting"
                                is-link 
                                arrow-direction="down" 
                                @click="handleItemClick(5, item.FileURL, '')"	
                                class="item-cell"	 
                            />   
                        </van-cell-group>
                    </van-collapse-item>
                    
                    <van-collapse-item name="6">    
                        <template #title>
                            <div>固件 <van-badge :content="fwNumber" max="9"/></div>
                        </template>         
                        <van-cell-group inset>
                            <van-cell 
                                v-for="item in fwlist" 
                                :key="item.RecID" 
                                :title="item.FileCaption"
                                icon="setting"
                                is-link 
                                arrow-direction="down" 
                                :label="item.detail"
                                @click="handleItemClick(6, item.FileURL, '')"	
                                class="item-cell"	 
                            />   
                        </van-cell-group>
                    </van-collapse-item>
                </van-collapse>
            </div>
            <div class="search-tip">可以输入关键词查询</div>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
import Vue from 'vue'
import 'vant/lib/icon/local.css';
import VueClipboard from 'vue-clipboard2';
Vue.use(VueClipboard);
import { Dialog } from 'vant';
import { Toast } from 'vant'
import global from '../../components/global.vue';   
import DeviceCard from '../../components/devicecard.vue';
import TopBar from '../../components/topNav.vue';

// 常量定义
const API_BASE_URL = 'https://t3.lenovoimage.com/api/Web2/productinfolist';
const DIALOG_MESSAGES = {
    VIEW_TIP: '点击直接查看',
    DOWNLOAD_TIP: '推荐您可以粘贴到PC浏览器地址栏目使用PC下载',
    COPY_SUCCESS: '拷贝完成！'
};

export default {
    name: 'ProductInfo',
    components: {	 
        DeviceCard,
        TopBar
    },
    data() {
        return {	            
            keyword: '',
            searchValue: '',
            fwlist: [],		
            driverlist: [],		
            manuallist: [],		
            videolist: [],
            guidelist: [],		
            qalist: [],		
            productlines: [],
            activeNames: [1, 2, 3, 4, 5],
            Driver: require("@/assets/driver2.png"),
            rows: 0,
            guideNumber: 0,
            driverNumber: 0,
            fwNumber: 0,
            qaNumber: 0,
            manualNumber: 0,
            videoNumber: 0,
            sn: '',
            pn: '',
            model: ''
        };
    },
    created() {
        console.log(this.$route.query, 'route query');    
        this.keyword = this.$route.query.model;
        this.searchValue = this.keyword;
        this.getDataList();
    },     
    mounted() {
        document.title = '产品信息';
    },
    methods: {	
        /**
         * 设备变更处理
         */
        onChange(device) {
            console.log(device, 'device change');
            this.model = device.Model;
            this.keyword = device.Model;
            this.getDataList();
        },
        
        /**
         * 搜索处理
         */
        onSearch() {
            this.keyword = this.searchValue;
            console.log(this.keyword, 'keyword');
            this.getDataList();	
        },
        
        /**
         * 取消搜索
         */
        onCancel() {
            this.driverlist = [];
        },
        
        /**
         * 获取数据列表
         */
        getDataList() {
            const that = this;
            const params = `appid=svchome&keywords=${this.keyword}&sn=${this.sn}`;
            
            Vue.axios.get(`${API_BASE_URL}?${params}`)
                .then(function(response) {
                    console.log(response, 'response');
                    that.handleDataResponse(response);
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        
        /**
         * 处理数据响应
         */
        handleDataResponse(response) {
            if (response.data.Status === "0") {
                const data = response.data.Data;
                this.updateListData(data);
            }
        },
        
        /**
         * 更新列表数据
         */
        updateListData(data) {
            this.driverlist = data.Table || [];
            this.driverNumber = this.driverlist.length;

            this.fwlist = data.Table1 || [];
            this.fwNumber = this.fwlist.length;

            this.manuallist = data.Table2 || [];
            this.manualNumber = this.manuallist.length;

            this.guidelist = data.Table3 || [];
            this.guideNumber = this.guidelist.length;

            this.qalist = data.Table5 || [];
            this.qaNumber = this.qalist.length;

            this.videolist = data.Table4 || [];
            this.videoNumber = this.videolist.length;

            console.log(this.driverlist, 'driverlist');
        },
        
        /**
         * 处理项目点击
         */
        handleItemClick(type, url, viewUrl) {		
            const handlers = {
                1: () => this.handleGuideClick(viewUrl),
                2: () => this.handleManualClick(viewUrl),
                3: () => this.handleVideoClick(url),
                4: () => this.handleQAClick(url),
                5: () => this.handleDriverClick(url),
                6: () => this.handleFirmwareClick(url)
            };
            
            const handler = handlers[type];
            if (handler) {
                handler();
            }
        },
        
        /**
         * 处理安装指南点击
         */
        handleGuideClick(viewUrl) {
            this.showViewDialog(viewUrl);
        },
        
        /**
         * 处理用户手册点击
         */
        handleManualClick(viewUrl) {
            this.showViewDialog(viewUrl);
        },
        
        /**
         * 处理安装视频点击
         */
        handleVideoClick(url) {
            this.showViewDialog(url);
        },
        
        /**
         * 处理问答点击
         */
        handleQAClick(qaId) {
            this.$router.push({ path: '/productinfo/showContents?qaid=' + qaId });
        },
        
        /**
         * 处理驱动点击
         */
        handleDriverClick(url) {
            Dialog.confirm({
                title: '温馨提示',
                message: DIALOG_MESSAGES.DOWNLOAD_TIP,
                confirmButtonText: '拷贝到剪贴板',
                showCancelButton: false
            }).then(() => {
                this.copyToClipboard(url);
            });
        },
        
        /**
         * 处理固件点击
         */
        handleFirmwareClick(url) {
            // 固件处理逻辑，可根据需要添加
            console.log('固件点击:', url);
        },
        
        /**
         * 显示查看对话框
         */
        showViewDialog(url) {
            Dialog.confirm({
                title: '温馨提示',
                message: DIALOG_MESSAGES.VIEW_TIP,
                confirmButtonText: '直接查看',
                showCancelButton: false
            }).then(() => {
                this.$router.push({ path: '/productinfo/openPDF?pdfurl=' + url });
            });
        },
        
        /**
         * 复制到剪贴板
         */
        copyToClipboard(text) {
            this.$copyText(text);
            Toast({
                message: DIALOG_MESSAGES.COPY_SUCCESS,
                icon: 'like-o'
            });
        },
        
        /**
         * 返回首页
         */
        onClickLeft() {
            this.$router.push({ path: '/' });
        }
    }
}
</script>

<style scoped>
.container {
    margin-top: 0px;
    font-size: 14px;
} 

.item {
    text-align: left;
    margin: 3px;
    max-width: 100%;
    font-size: 14px;
}

.item-cell {
    height: 60px;
    background-color: #f0f0f0;
    word-break: break-all;
    word-wrap: break-word; 
}  

.item-cell span {
    word-break: break-all;
    word-wrap: break-word; 
    font-size: 12px;
} 

.swiper-item {        
    display: flex;  
    margin: 5px;
    background-color: transparent;
}

.icon-box {
    width: 50%;
}

.icon {
    max-width: 80%;
}

.device-title {
    width: 70%;
    text-align: left; 
}

.model {
    font-size: 18px;
    font-weight: 600;
    margin-top: 20px;
    width: 100%;
}    

.sn {
    font-size: 12px;
    margin-top: 5px;
    width: 100%;
    color: darkgray;
}     

.search-tip {
    text-align: center;
    margin-top: 50px;
    color: #969799;
    font-size: 14px;
}
</style>